const permissionConfig = [
  {
    role: "Admin",
    show: [
      "Dashboard",
      "Participants",
      "Lifestyle/Activity",
      "Location",
      "Language",
      "Registered Users",
      "Speakers",
      "Sponsors",
      "Organizers",
      "EventTypes",
      "All Events",
      "Livestreams",
      "Add New Event",
      "Category",
      "Orders",
      "Settings",
      "Payment Gateway",
    ],
  },
  {
    role: "Speaker",
    show: [
      "Dashboard",
      "Livestreams",
      "All Events",
      "Add New Event",
      "Settings",
      "Payment Gateway",
    ],
  },
  {
    role: "Participants",
    show: ["Dashboard", "Livestreams",],
  },
];

export default permissionConfig;
